import { useMemo } from 'react';
import DOMPurify from 'dompurify';

export const useSanitize = (string: string): string => {
    return useMemo(() => DOMPurify.sanitize(string), [string]);
};
